<footer  class="bg-white border-t border-mint/10 py-12 md:py-16">
  <div id="footer" class="container mx-auto px-4 md:px-6">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
      <div>
        <a routerLink="/" class="flex items-center space-x-2 mb-5">
          <span class="font-cormorant text-2xl font-bold text-forest">
            <img [src]="logo" />
          </span>
        </a>
        <p class="text-forest/70 text-sm mb-6 max-w-xs">
          Premium quality organic herbs and supplements, crafted with care for your wellness journey.
        </p>
        <div class="flex space-x-4">
          <a href="https://www.instagram.com/witharthawell?utm_source=qr&igsh=Y2s0ankxNGthc3Fv" class="p-2 rounded-full bg-mint/10 hover:bg-mint/30 transition-colors duration-200">
            <i-lucide [img]="instagram" class="text-forest" size="18"></i-lucide>
          </a>
          <a href="https://www.facebook.com/profile.php?id=61575297414410" class="p-2 rounded-full bg-mint/10 hover:bg-mint/30 transition-colors duration-200">
            <i-lucide [img]="facebook" class="text-forest" size="18"></i-lucide>
          </a>
          <a href="https://x.com/witharthawell" class="p-2 rounded-full bg-mint/10 hover:bg-mint/30 transition-colors duration-200">
            <i-lucide [img]="twitter" class="text-forest" size="18"></i-lucide>
          </a>
        </div>
      </div>

      <div>
        <h3 class="font-medium text-forest mb-5">Shop</h3>
        <ul class="space-y-3">
          <li *ngFor="let item of shopLinks">
            <a routerLink="{{ item.toLowerCase().split(' ').join('-') }}" class="text-sm text-forest/70 hover:text-mint-dark transition-colors duration-200">
              {{ item }}
            </a>
          </li>
        </ul>
      </div>

      <div>
        <h3 class="font-medium text-forest mb-5">About</h3>
        <ul class="space-y-3">
          <li *ngFor="let item of aboutLinks">
            <a routerLink="{{ item.link }}" class="text-sm text-forest/70 hover:text-mint-dark transition-colors duration-200">
              {{ item.title }}
            </a>
          </li>
        </ul>
      </div>

      <div>
        <h3 class="font-medium text-forest mb-5">Help</h3>
        <ul class="space-y-3">
          <li *ngFor="let item of helpLinks">
            <a routerLink="{{ item.link }}" class="text-sm text-forest/70 hover:text-mint-dark transition-colors duration-200">
                {{ item.title }}
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div class="mt-12 pt-8 border-t border-mint/10 flex flex-col md:flex-row justify-between items-center">
      <p class="text-sm text-forest/60 mb-4 md:mb-0">
        &copy; {{ currentYear }} Arthawell. All rights reserved.
      </p>
      <p class="text-sm text-forest/60 flex items-center">
        Made with
        <i-lucide [img]="heart" class="inline-block mx-1 text-forest/60" [attr.fill]="'currentColor'" size="14"></i-lucide>
        for a healthier world
      </p>
    </div>
  </div>
</footer>
